var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CollectorSetupResultStatus } from "./collector-setup-result";
class Collector {
    constructor(options, plasm) {
        this.plasm = plasm;
        this.validateOptions(options);
        this.options = options;
    }
    setup() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.plasm.supportedCollectors.includes(this.id) === false) {
                return this.buildSetupResult(CollectorSetupResultStatus.not_supported);
            }
            return this.setupCollector();
        });
    }
    validateOptions(options) { }
    buildSetupResult(status) {
        return {
            id: this.id,
            status,
            meta: this.buildSetupMeta(),
        };
    }
    stop() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.stopInner();
            this.plasm.debug(`[${this.id}] stopped`);
        });
    }
    setOptions(options) {
        this.validateOptions(options);
        this.options = options;
    }
    setPubSubEventCollector(pubSubEvent) { }
}
export default Collector;
